import styled from 'styled-components'

export const StyledContainer = styled.div<{
  interactive: boolean
  opened: boolean
  zIndex?: number
}>`
  display: block;
  opacity: ${props => (props.opened ? 1 : 0)};
  visibility: ${props => (props.opened ? 'inherit' : 'hidden')};
  transition: opacity 200ms ease;
  z-index: ${props => (props.zIndex ? props.zIndex : 12)};
  pointer-events: ${props => (props.interactive ? 'auto' : 'none')};
`
